export const env = 'dev';
export const baseUrl = 'https://pay.api.dev.surepoint.cloud/';
export const pageTitle = '[DEV] SurePoint Pay';
